export const categories = [
  {
    slug: 'zixing-yanbian',
    name: '字形演变',
    description: '追溯「淫」字从甲骨文、金文、篆书到楷书的字形变迁历程，揭示其构字理据与书写演变。',
    icon: 'ri-brush-line',
    articleCount: 3,
  },
  {
    slug: 'yuyi-jiexi',
    name: '语义解析',
    description: '深入分析「淫」字的本义、引申义及其语义网络，探讨汉字语义的层累与分化。',
    icon: 'ri-mind-map',
    articleCount: 3,
  },
  {
    slug: 'guji-yongli',
    name: '古籍用例',
    description: '撷取先秦至明清经典文献中「淫」字的典型用例，展现其在不同语境中的具体用法。',
    icon: 'ri-book-open-line',
    articleCount: 3,
  },
  {
    slug: 'wenhua-yanjiu',
    name: '文化研究',
    description: '从儒学礼教、文艺批评等维度，探讨「淫」字所承载的文化观念与价值判断。',
    icon: 'ri-landscape-line',
    articleCount: 2,
  },
  {
    slug: 'xiandai-yujing',
    name: '现代语境',
    description: '考察「淫」字在现代汉语中的使用频率、语义范围及社会认知变迁。',
    icon: 'ri-global-line',
    articleCount: 1,
  },
];

export const categoryMap: Record<string, typeof categories[0]> = {};
categories.forEach((cat) => {
  categoryMap[cat.slug] = cat;
});